/**
 * SiteFooter 스타일
 * @description FanTrip 공통 푸터(`fantrip/Dev/FE` `widgets/site-footer`, Figma 모바일 613:7875 /
 *   중간 1004:11480 / PC 1006:6325)와 같은 수치다. 폰은 세로로 쌓고, 태블릿부터 회사 정보(왼쪽)와
 *   대표전화·SNS(오른쪽, 오른쪽 정렬)로 나뉜다. 위 여백(60 / 120 / 200)이 본문 마지막 섹션과의
 *   간격을 맡으므로 구분선을 두지 않는다. 토큰에 같은 값이 없는 수치(20·40·60…)만 그대로 적었다.
 */
export const siteFooterStyles = {
  root: "w-full px-[20px] pt-[60px] pb-[40px] tablet:px-[40px] tablet:pt-[120px] tablet:pb-[20px] desktop:pt-[200px] desktop:pb-[40px]",
  row: "flex flex-col gap-[var(--fw-space-gap-lg)] tablet:flex-row tablet:items-start tablet:justify-between tablet:gap-[40px]",
  company: "flex min-w-0 flex-col gap-[var(--fw-space-gap-sm)]",
  /* FanTrip `text-h3-tight` 은 자간 -1px 이다 — 이쪽 `fw-h3-tight` 토큰은 0 이라 덮어쓴다 */
  brand:
    "fw-h3-tight tracking-[-1px] text-[var(--fw-color-content-neutral-secondary)]",
  links:
    "fw-caption flex flex-wrap gap-x-[var(--fw-space-gap-md)] gap-y-[var(--fw-space-gap-xs)] text-[var(--fw-color-content-neutral-secondary)] tablet:gap-x-[var(--fw-space-gap-sm)]",
  link: "hover:underline",
  /* 회사명·대표 사이 두 칸, 등록번호 사이 "  ·  " 를 그대로 보이게 공백을 살린다 */
  info: "fw-caption whitespace-pre-wrap text-[var(--fw-color-content-neutral-tertiary)] [word-break:keep-all]",
  registration: "block tablet:inline",
  registrationSeparator: "hidden tablet:inline",
  contact:
    "flex shrink-0 flex-col gap-[var(--fw-space-gap-lg)] tablet:items-end",
  tel: "flex flex-col gap-[var(--fw-space-gap-xs)] tablet:items-end",
  telLabel: "fw-caption text-[var(--fw-color-content-neutral-tertiary)]",
  telNumber: "fw-h4 text-[var(--fw-color-content-neutral-secondary)]",
  sns: "flex gap-[var(--fw-space-gap-md)]",
  snsLink:
    "flex size-5 items-center justify-center text-[var(--fw-color-content-neutral-tertiary)]",
};

export const SITE_FOOTER_SNS_ICON_SIZE = 20;
